
export default function WomanIcon({...props}) {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 21 21.23"
          {...props}
        >
          <g transform="translate(-5 -5)">
            <circle
              data-name="Ellipse 5"
              cx={10.5}
              cy={10.5}
              r={10.5}
              transform="translate(5 5)"
              fill="#f26522"
            />
            <path
              data-name="Path 52"
              d="M20.872 18.368l-.786-3.468a5.268 5.268 0 00-4.423-4.875h-.083a5.268 5.268 0 00-4.423 4.875l-.786 3.468a.814.814 0 00.881.995l4.364-.448 4.38.452a.814.814 0 00.877-1z"
              fill="#262234"
            />
            <path
              data-name="Path 53"
              d="M22.201 23.933a10.592 10.592 0 01-13.171 0l.295-1.046a3.578 3.578 0 012.755-2.479 3.251 3.251 0 01.7-.075h5.67a3.251 3.251 0 01.708.075 3.578 3.578 0 012.748 2.481z"
              fill="#5a143c"
            />
            <path
              data-name="Path 54"
              d="M17.188 18.737v3.169l-1.573.786-1.572-.787v-3.168a.37.37 0 01.37-.37h2.4a.37.37 0 01.373.37z"
              fill="#ffd2b4"
            />
            <path
              data-name="Path 55"
              d="M15.615 9.014c4.325 0 3.971 4.242 3.971 4.242.637-.067 1.14.193 1.14 1.124s-.393 1.124-.889 1.179a.11.11 0 00-.1.106 4.724 4.724 0 01-2.115 3.224 3.377 3.377 0 01-4.006 0 4.733 4.733 0 01-2.118-3.223.11.11 0 00-.1-.106c-.5-.051-.889-.248-.889-1.179s.48-1.179 1.117-1.124c-.005-.001-.359-4.243 3.989-4.243z"
              fill="#ffd2b4"
            />
            <circle
              data-name="Ellipse 6"
              cx={0.668}
              cy={0.668}
              r={0.668}
              transform="translate(13.39 13.433)"
              fill="#262234"
            />
            <circle
              data-name="Ellipse 7"
              cx={0.668}
              cy={0.668}
              r={0.668}
              transform="translate(16.504 13.433)"
              fill="#262234"
            />
            <path
              data-name="Path 56"
              d="M17.136 15.824a.393.393 0 01.393.491 1.966 1.966 0 01-3.806 0 .393.393 0 01.393-.491z"
              fill="#611c24"
            />
            <path
              data-name="Path 57"
              d="M16.567 17.545a1.966 1.966 0 01-1.9 0c.079-.484.476-.617.951-.617s.866.134.949.617z"
              fill="#be1e2d"
            />
            <path
              data-name="Path 58"
              d="M16.745 15.824v.37a.145.145 0 01-.142.145h-1.966a.145.145 0 01-.142-.145v-.37z"
              fill="#fff"
            />
            <path
              data-name="Path 59"
              d="M18.363 20.333a2.776 2.776 0 01-5.5 0z"
              fill="#ffd2b4"
            />
            <path
              data-name="Path 60"
              d="M18.45 20.333h-.079a2.776 2.776 0 01-5.5 0h-.075a3.251 3.251 0 00-.708.075 3.562 3.562 0 007.077 0 3.251 3.251 0 00-.715-.075z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 61"
              d="M17.188 19.154v.786a3.342 3.342 0 01-3.145 0v-.786a3.342 3.342 0 003.145 0z"
              fill="#262234"
              opacity={0.1}
            />
            <path
              data-name="Path 62"
              d="M20.136 11.762c-.196-2.697-2.606-3.617-4.521-3.617s-4.325.92-4.521 3.617a4.45 4.45 0 00.039 1.345 12.421 12.421 0 00.157 1.431c.071.307.421.295.468.02a10.639 10.639 0 01.393-1.875 8.192 8.192 0 004.4-1.439 8.453 8.453 0 002.614 1.5 10.729 10.729 0 01.358 1.812c.043.275.393.287.468-.02a12.1 12.1 0 00.134-1.4 4.415 4.415 0 00.011-1.374z"
              fill="#262234"
            />
          </g>
        </svg>
      )
}
